module.exports = __webpack_public_path__ + "static/media/IsometricPressMale.a74ab1cd.svg";